import { ShoppingCart } from 'app/api/@generated/backend';

import {
    selectBroadbandOfferIdOrThrow,
    selectSelectedAccountOrThrow,
    selectSelectedServiceLocationOrThrow,
} from 'app/pages/order/redux/order-selector';
import { ShoppingCartService } from 'app/pages/order/services/shopping-cart-service';
import { createAppAsyncThunk } from 'app/redux/utils/thunk-utils';
import { RequestType } from 'app/pages/order/redux/model/order-request';

export const initializeShoppingCartActionCreator = createAppAsyncThunk<ShoppingCart>(
    'order/initializeShoppingCart',
    async (_, { getState }) => {
        const rootState = getState();
        const selectedAccount = selectSelectedAccountOrThrow(rootState);
        const { customerId, partnerId } = selectedAccount;
        const serviceLocation = selectSelectedServiceLocationOrThrow(rootState);
        const broadbandOfferId = selectBroadbandOfferIdOrThrow(rootState);
        const { integrationId } = serviceLocation;

        return ShoppingCartService.initializeShoppingCart(partnerId, customerId, integrationId, broadbandOfferId);
    },
    {
        getPendingMeta: () => ({ requestType: RequestType.INITIALIZE_SHOPPING_CART }),
    },
);
